import { getViewState } from '@aegislab/shared';

/**
 * 뷰 상태 술어.
 *
 * `index.ts` 본문이 아니라 별도 모듈에 두는 이유: 같은 세그먼트의 `appNav.ts` 가
 * 이 술어를 쓰는데, 배럴(`index.ts`)에서 가져오면 `index.ts → appNav.ts → index.ts`
 * 자기참조 순환이 된다. `appNav.ts` 는 `./viewState` 를 직접 임포트한다.
 *
 * 이 모듈은 부수효과가 없어야 한다 — `index.ts` 는 `applyFeatureFlagOverrides` 와
 * `document.title` 을 건드리므로 node 러너 테스트에서 `document` 가 없어 터진다.
 */

/** 특정 뷰가 티저 모드인지 확인. BETA_TESTER 캐퍼빌리티를 가진 팀은 teaser를 우회해 live로 처리 */
export function isTeaserView(viewId: string, teamCapabilities?: string[]): boolean {
  return getViewState(viewId, teamCapabilities) === 'teaser';
}

/** 특정 뷰가 피처 플래그로 숨김인지 확인. hidden은 BETA_TESTER도 우회 못함 */
export function isHiddenView(viewId: string, teamCapabilities?: string[]): boolean {
  return getViewState(viewId, teamCapabilities) === 'hidden';
}
